import { render, staticRenderFns } from "./OurTransportCargoListBlock.vue?vue&type=template&id=1e9584e3&scoped=true&"
import script from "./OurTransportCargoListBlock.vue?vue&type=script&lang=js&"
export * from "./OurTransportCargoListBlock.vue?vue&type=script&lang=js&"
import style0 from "./OurTransportCargoListBlock.vue?vue&type=style&index=0&id=1e9584e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9584e3",
  null
  
)

export default component.exports